<template>
  <b-container>
    <b-row class="m-0">
      <b-col md="1" />
      <b-col
        lg="10"
        class="d-flex align-items-center justify-content-center px-2 p-lg-5"
      >
        <b-col
          sm="10"
          md="8"
          lg="9"
          class="px-xl-2 mx-auto"
        >
          <validation-observer
            ref="CategoryForm"
            #default="{ invalid }"
          >
            <b-form
              class="mt-2"
              @submit.prevent="submitCategory"
            >
              <b-form-group
                class="mb-3"
                label="Category Name"
                label-for="Category-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="CategoryName"
                  vid="Category-name"
                  rules="required"
                >
                  <b-form-input
                    id="Category-name"
                    v-model="CategoryForm.name"
                    name="Category-name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Category Name"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- <b-form-group
                class="mb-3"
                label="Category Description"
                label-for="Category-description"
              >
                <validation-provider
                  #default="{ errors }"
                  name="CategoryDescription"
                  vid="Category-description"
                  rules="required"
                >
                  <b-form-input
                    id="Category-description"
                    v-model="CategoryForm.description"
                    name="Category-description"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Category Description"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group> -->
              <b-row
                class="w-100 d-flex align-items-center justify-content-center p-0 py-50"
              >
                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="invalid || isLoading"
                  style="
                    background-color: #727272 !important;
                    border: unset !important;
                  "
                >
                  <b-spinner
                    v-if="isLoading"
                    type="grow"
                    small
                    class="ml-1"
                  />
                  <span v-else>
                    <span>
                      {{ categoryID ? "Update" : "Create" }}
                    </span>
                  </span>
                </b-button>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <b-col md="1" />
    </b-row>
  </b-container>
</template>

<script>
import { required, image } from '@validations'
import { mapGetters } from 'vuex'

import {
  BSpinner,
  BContainer,
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormSelect,
  BFormInput,
  BFormGroup,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import categories from '@/router/routes/categories'

export default {
  components: {
    BSpinner,
    BContainer,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormFile,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapGetters({
      item: 'experiments/item',
    }),
    categoryID() {
      return this.$route.params.id ? this.$route.params.id : null
    },
    categoryOptions() {
      if (!this.categories || this.categories.length === 0) {
        return [{ value: null, text: 'Loading categories...' }]
      }

      return [{ value: null, text: 'Please select an option' },
        ...this.categories.map(category => ({
          value: category.id,
          text: category.name,
        }))]
    },
  },
  data() {
    return {
      isLoading: false,
      CategoryForm: {
        name: '',
        // description: "",
      },
      categories: [],

      // validation rules
      required,
      image,
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    getCategories() {
      const fakeResponse = [
        { id: 1, name: 'HVAC', description: 'All kinds of HVAC systems' },
        {
          id: 2,
          name: 'Engineering',
          description: 'Engineering principles and practices',
        },
        {
          id: 3,
          name: 'Science',
          description: 'Scientific methods and discoveries',
        },
      ]

      this.categories = fakeResponse
    },

    async init() {
      await this.getCategories()
      if (this.categoryID) {
        this.$store
          .dispatch('categories/get', this.categoryID)
          .then(response => {
            this.CategoryForm.name = response.name
          //  this.CategoryForm.description=response.description
          })
          .catch(e => {
            this.$swal({
              icon: 'error',
              title: `<h4>Error fetching experiment details: ${e.message}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#7367f0',
              allowOutsideClick: true,
            })
          })
      }
    },
    submitCategory() {
      this.$refs.CategoryForm.validate().then(success => {
        if (success) {
          this.isLoading = true
          if (this.categoryID) {
            this.$store
              .dispatch('categories/update', {
                query: this.CategoryForm,
                id: this.categoryID,
              })
              .then(response => {
                this.$swal({
                  icon: 'success',
                  title: '<h4>Category updated successfully! </h4>',
                  showConfirmButton: true,
                  confirmButtonColor: '#7367f0',
                  allowOutsideClick: true,
                })
                this.$store.dispatch('categories/categoryLookups')
                this.$root.$emit('categoryCreated')
                this.isLoading = false
                this.$router.push({
                  name: 'categories',
                })
              })
              .catch(error => {
                this.isLoading = false
                if (error.response) {
                  this.$swal({
                    icon: 'error',
                    title: `<h4>${error.response.data.error}</h4> `,
                    showConfirmButton: true,
                    confirmButtonColor: '#7367f0',
                    allowOutsideClick: true,
                  })
                }
              })
          } else {
            console.log('CREATING category with formData:', this.CategoryForm)
            this.$store
              .dispatch('categories/put', this.CategoryForm)
              .then(response => {
                this.$swal({
                  icon: 'success',
                  title: '<h4>Category created successfully! </h4>',
                  showConfirmButton: true,
                  confirmButtonColor: '#7367f0',
                  allowOutsideClick: true,
                })
                this.$store.dispatch('categories/categoryLookups')
                this.$root.$emit('categoryCreated')
                this.$router.push({
                  name: 'categories',
                })
                this.isLoading = false
              })
              .catch(error => {
                this.isLoading = false
                if (error.response) {
                  this.$swal({
                    icon: 'error',
                    title: `<h4>${error.response.data.error ? error.response.data.errors[0] : error.response.data.message}</h4> `,
                    showConfirmButton: true,
                    confirmButtonColor: '#7367f0',
                    allowOutsideClick: true,
                  })
                }
              })
          }
        } else {
          this.$swal({
            icon: 'error',
            title: `<h4>Validation Error: ${error.response.data.message}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        }
      })
    },
  },
}
</script>
<style>

</style>
